import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SiteLayout } from "../../components/site/SiteLayout";
import { useSeo } from "../../lib/seo";
import { productWaldInsights } from "../../lib/content";
import { CTABlock } from "../ServicesPage";

export default function WaldInsightsPage() {
  useSeo({
    title: "WaldInsights",
    description: productWaldInsights.tagline,
    path: "/products/waldinsights",
  });
  return (
    <SiteLayout>
      <section className="border-b border-border">
        <div className="container-wald py-12">
          <Link to="/products" data-testid="waldinsights-back" className="inline-flex items-center gap-2 text-sm opacity-70 hover:opacity-100">
            <ArrowLeft size={14} strokeWidth={2} /> All products
          </Link>
        </div>
      </section>
      <section className="border-b border-border">
        <div className="container-wald py-20 md:py-28">
          <div className="eyebrow mb-6">Product · {productWaldInsights.title}</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-4xl">
            {productWaldInsights.tagline}
          </h1>
          <p className="mt-6 max-w-2xl opacity-85 leading-relaxed text-lg">{productWaldInsights.intro}</p>
        </div>
      </section>
      <CTABlock />
    </SiteLayout>
  );
}
